export default "__VITE_ASSET__2c6f0d25__"